import React, { FC } from 'react';
import styled from 'astroturf/react';
import { Spinner } from 'js/social/shared/CreateSocialItem/Spinner';
import { Menu } from 'js/design_system/Menu';
import { PopoverMode, PopoverProps } from 'js/design_system/Popover';
import { default as UserCardBase, Props as UserProps } from '../UserCard';
import _Container from "UserListMenu-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/UserListMenu/UserListMenu.tsx?styleId=Container";
import _LoadingContainer from "UserListMenu-LoadingContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/UserListMenu/UserListMenu.tsx?styleId=LoadingContainer";
import _UserCard from "UserListMenu-UserCard.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/UserListMenu/UserListMenu.tsx?styleId=UserCard";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const LoadingContainer = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingContainer",
  styles: _LoadingContainer
});

const UserCard = /*#__PURE__*/styled(UserCardBase, null, {
  displayName: "UserCard",
  styles: _UserCard
});

type UserType = Omit<UserProps, 'className'> & { id: number };

export type Props = {
  users: UserType[];
  loading?: boolean;
  className?: string;
  menuProps?: Partial<PopoverProps>;
  size?: 'regular' | 'small';
};

export const UserListMenu: FC<React.PropsWithChildren<Props>> = ({
  users,
  loading = false,
  className,
  children,
  menuProps = {},
  size = 'regular',
}) => (
  <Menu
    placement="bottom-start"
    mode={PopoverMode.Any}
    className={className}
    render={() => (
      <Container>
        {loading ? (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        ) : (
          <ul>
            {users.map((user) => (
              <li key={user.id}>
                <a href={user.profileUrl}>
                  <UserCard
                    {...user}
                    profileUrl={undefined}
                    size={size}
                    truncateText
                  />
                </a>
              </li>
            ))}
          </ul>
        )}
      </Container>
    )}
    {...menuProps}
  >
    {children}
  </Menu>
);
